import { CashCountService } from '@/services'

// eslint-disable-next-line import/no-anonymous-default-export
export const serviceMapper = {
  cashCount: CashCountService,
}
